export default __webpack_public_path__ + "static/media/template1.9abdb306.svg";